import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'jl-design-system/components/modal/Modal';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import { dispatchAnalyticsEventWithAction } from '../../app/analytics/analytics.utils';

import { SignupForm } from './SignupForm';
import styles from './email-signup.scss';

const FormPage = ({ onSuccess, hasError }) => (
  <React.Fragment>
    <SignupForm onSuccess={onSuccess} hasError={hasError} />
    <p className={styles.privacy_notice}>
      We treat your personal data with care, view our{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.johnlewis.com/customer-services/shopping-with-us/privacy-notice"
      >
        privacy notice
      </a>{' '}
      here.
    </p>
  </React.Fragment>
);

const SuccessPage = ({ onClose }) => (
  <React.Fragment>
    <div className={styles.success__tick} />
    <p className={styles.success__text}>
      You&#39;re now signed up and your first email will be on its way to you soon.
    </p>
    <PrimaryButton type="button" onClick={onClose}>
      Continue shopping
    </PrimaryButton>
  </React.Fragment>
);

class SignupModal extends React.Component {
  constructor() {
    super();
    this.state = {
      submitted: false,
      error: false,
    };

    this.hasError = this.hasError.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeSuccessModal = this.closeSuccessModal.bind(this);
    this.formSubmitted = this.formSubmitted.bind(this);
  }

  componentDidMount() {
    dispatchAnalyticsEventWithAction('pageload.signup');
  }

  hasError(error = true) {
    this.setState({ error });
  }

  formSubmitted() {
    dispatchAnalyticsEventWithAction('signup.submit');
    this.setState({ submitted: true });

    // update LocalStorage to ensure the customer doesn't see the browse header banner again
    const supportsLocalStorage = localStorage && typeof localStorage.setItem === 'function';
    if (supportsLocalStorage) {
      // this is consumed in cms-header-banner.hbs in browse project
      localStorage.setItem('Email Signup Completed', 'true');
    }
  }

  closeSuccessModal() {
    dispatchAnalyticsEventWithAction('signup.continue-shopping');
    this.props.onClose();
  }

  closeModal() {
    dispatchAnalyticsEventWithAction('signup.close');
    this.props.onClose();
  }

  render() {
    const formSubmitted = this.state.submitted;
    const modalTitle = formSubmitted ? 'Thank you' : 'Sign me up for emails';
    const renderPage = formSubmitted ? (
      <SuccessPage onClose={this.closeSuccessModal} />
    ) : (
      <FormPage onSuccess={this.formSubmitted} hasError={this.hasError} />
    );

    return (
      <Modal title={modalTitle} isOpen onClose={this.closeModal} rootId="root" footer={false}>
        <div
          className={[
            !formSubmitted ? [styles.modal] : '',
            formSubmitted ? [styles.modal__success] : '',
            this.state.error ? [styles.modal__hasError] : '',
          ].join(' ')}
        >
          <div className={styles.modal__content}>{renderPage}</div>
        </div>
      </Modal>
    );
  }
}

SignupModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default SignupModal;
